export default __webpack_public_path__ + "static/media/home3.16c04be4.jpg";